'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ShowValuesCheckbox = undefined;

var _Style = require('./Style');

var _Style2 = _interopRequireDefault(_Style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShowValuesCheckbox = function ShowValuesCheckbox(refs) {
    var i18n = refs.i18nManager.get();

    return Ext.create('Ext.form.field.Checkbox', {
        boxLabel: i18n.show_values,
        style: 'margin-bottom:' + _Style2.default.checkboxBottomMargin + 'px',
        checked: true
    });
};

exports.ShowValuesCheckbox = ShowValuesCheckbox;
exports.default = ShowValuesCheckbox;
//# sourceMappingURL=ShowValues.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/options/ShowValues.js
 ** module id = 359
 ** module chunks = 0
 **/